import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import dayjs from "dayjs";
import {
  hasChartRecordData,
  normalizeChartRecord,
} from "../../../utils/chartData";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const BAR_HEIGHTS = [38, 58, 44, 76, 32, 66, 50, 84, 40, 72, 52, 70];

const ColumnChartEmpty = () => (
  <div style={{ padding: "8px 12px 0" }}>
    <div style={{ display: "flex", alignItems: "flex-end", gap: 5, height: 260 }}>
      {BAR_HEIGHTS.map((h, i) => (
        <div
          key={i}
          style={{
            flex: 1,
            height: `${h}%`,
            borderRadius: "4px 4px 0 0",
            background: i % 2 === 0 ? "#e9eaec" : "#eff0f2",
          }}
        />
      ))}
    </div>
    <div style={{ display: "flex", borderTop: "1px solid #f0f0f0", paddingTop: 7 }}>
      {MONTHS.map((m) => (
        <div key={m} style={{ flex: 1, textAlign: "center", fontSize: 10, color: "#c4c9d4" }}>
          {m}
        </div>
      ))}
    </div>
    <div style={{ textAlign: "center", marginTop: 12, fontSize: 12, color: "#9ca3af" }}>
      No registration data yet
    </div>
  </div>
);

const ColumnChart = ({
  data,
}: {
  data: Record<string, string | number> | [] | null;
}) => {
  let categories: string[] = [];
  let seriesData: number[] = [];

  const normalized = normalizeChartRecord(data);
  if (normalized) {
    const entries = Object.entries(normalized);

    if (entries.length > 15) {
      const monthTotals: Record<string, number> = {};
      for (const [dateStr, valueStr] of entries) {
        const month = dayjs(dateStr).format("MMM");
        monthTotals[month] = (monthTotals[month] || 0) + Number(valueStr);
      }
      categories = Object.keys(monthTotals);
      seriesData = Object.values(monthTotals);
    } else {
      categories = entries.map(([dateStr]) => dayjs(dateStr).format("YYYY-MM-DD"));
      seriesData = entries.map(([, valueStr]) => Number(valueStr));
    }
  }

  const series = [{ name: "Registrations", data: seriesData }];

  const options: ApexOptions = {
    chart: { type: "bar" },
    plotOptions: {
      bar: { horizontal: false, columnWidth: "16px", borderRadius: 5, borderRadiusApplication: "end" },
    },
    dataLabels: { enabled: false },
    xaxis: { categories },
    legend: { position: "bottom" },
  };

  if (!hasChartRecordData(data)) return <ColumnChartEmpty />;

  return <Chart options={options} series={series} type="bar" height={350} />;
};

export default ColumnChart;
